import { useNavigate } from 'react-router-dom';
import { prospectsApi, type Prospect } from '@/api/client';
import { useAsync } from '@/hooks';
import { Layout } from '@/components/Layout';
import { DataTable } from '@/components/DataTable';
import { StatusBadge } from '@/components/StatusBadge';
import { Button } from '@/components/Button';
import { salesNavItems } from '@/pages/navItems';
import { formatDate } from '@/lib/format';

export function SalesProspects() {
  const navigate = useNavigate();
  const { data: prospects, loading, error, reload } = useAsync(() => prospectsApi.list(), []);

  const columns = [
    { key: 'companyName', header: 'Company' },
    { key: 'contactName', header: 'Contact' },
    {
      key: 'status',
      header: 'Status',
      render: (row: Prospect) => <StatusBadge status={row.status} size="sm" />,
    },
    {
      key: 'createdAt',
      header: 'Added',
      render: (row: Prospect) => formatDate(row.createdAt),
    },
  ];

  return (
    <Layout navItems={salesNavItems}>
      <div className="page">
        <div className="page-header row-between">
          <div>
            <h1>Prospects</h1>
            <p className="text-muted">Accounts you&apos;ve submitted and where each one stands</p>
          </div>
          <div className="row">
            <Button variant="secondary" type="button" onClick={() => reload()}>Refresh</Button>
            <Button type="button" onClick={() => navigate('/app/sales/submit')}>Submit account</Button>
          </div>
        </div>

        <DataTable
          columns={columns}
          data={prospects ?? []}
          keyField="id"
          loading={loading}
          dense
          loadError={error ? `Prospects couldn't be loaded. ${error}` : null}
          onRetry={() => void reload()}
          emptyMessage="No accounts submitted yet. Use “Submit account” to add your first one."
        />
      </div>
    </Layout>
  );
}
